import { Paths } from '../../lib/constants/path'
import LanguageTestDetails from './language-test-details'
import LagnuageTestList from './language-test-list'
import LanguageTestSectionDetails from './language-test-section-details'

export const languageTestRoutes = [
  {
    path: Paths.LANGUAGE_TEST_TEMPLATE_LIST_PAGE,
    element: <LagnuageTestList />
  },
  {
    path: Paths.LANGUAGE_TEST_TEMPLATE_DETAILS_PAGE,
    element: <LanguageTestDetails />
  },
  {
    path: Paths.LANGUAGE_TEST_TEMPLATE_SECTION_DETAILS_PAGE,
    element: <LanguageTestSectionDetails />
  }
]
